module.exports = __webpack_public_path__ + "travel.c41749d0c7d37af7dc83.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/travel/webfont/travel.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/travel/webfont/travel.eot
// module chunks = styles